import { ModelScene, useEntity } from 'components';
import type { ServiceCategory } from 'modules/supplier/outletOrServiceCategory/types';
import type { OutletOrServiceCategoryProduct } from 'modules/supplier/products';
import permissions from 'modules/supplier/outletOrServiceCategory/serviceCategoryPermissions';

import { useProductRoutes } from 'modules/supplier/products/useProductRoutes';

export function ServiceCategoryProducts() {
  const { endpoint, item } = useEntity<ServiceCategory>();
  const url = `${endpoint}products/`;

  const routes = useProductRoutes({ ...item, vendor_id: null });
  return (
    <ModelScene
      endpoint={url}
      title="Product"
      pluralTitle="Products"
      entityTitle={({ name }: OutletOrServiceCategoryProduct) => name || <em>Unspecified product</em>}
      permissions={permissions}
    >
      {routes}
    </ModelScene>
  );
}
